import { useQuery } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { queryClient } from "@/shared/services/queryClient";
import {
  vehiclesApi,
  type CreateVehicleRequest,
  type UpdateVehicleRequest,
} from "../services/vehiclesApi";

export const useVehicles = (activeOnly = true) =>
  useQuery({
    queryKey: ["vehicles", activeOnly],
    queryFn: () => vehiclesApi.getAll(activeOnly),
  });

export const useAllVehicles = () =>
  useQuery({
    queryKey: ["vehicles", "all"],
    queryFn: () => vehiclesApi.getAll(undefined),
  });

export const useCreateVehicle = () =>
  useMutation({
    mutationFn: (data: CreateVehicleRequest) => vehiclesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles"] });
      toast.success("Vehicle created.");
    },
    onError: (err: Error) => {
      toast.error(err.message ?? "Failed to create vehicle.");
    },
  });

export const useUpdateVehicle = () =>
  useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateVehicleRequest }) =>
      vehiclesApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles"] });
      toast.success("Vehicle updated.");
    },
    onError: (err: Error) => {
      toast.error(err.message ?? "Failed to update vehicle.");
    },
  });
